// 该文件在vite-plugin-permission-generator自动生成
// 不要手动编辑此文件，它会在每次权限变更时自动生成

export const PERMISSIONS = {
  "客户管理/创意中心/Creative访问白名单/删除白名单": "management:creative_whitelist:delete",
  "客户管理/创意中心/Creative访问白名单/成员选项": "management:creative_whitelist:option",
  "客户管理/创意中心/Creative访问白名单/批量添加": "management:creative_whitelist:add",
  "客户管理/创意中心/Creative访问白名单/白名单列表": "management:creative_whitelist:list",
  "团队管理/成员管理/删除成员": "management:member:delete",
  "团队管理/成员管理/启用/禁用成员": "management:member:switch_status",
  "团队管理/成员管理/成员分页列表": "management:member:list",
  "团队管理/成员管理/查询成员详情": "management:member:detail",
  "团队管理/成员管理/添加成员": "management:member:add",
  "团队管理/成员管理/编辑更新成员": "management:member:edit",
  "团队管理/角色&权限/获取角色列表": "management:role:list",
  "团队管理/角色&权限/获取角色详情": "management:role:detail",
  "团队管理/角色&权限/角色编辑更新": "management:role:edit",
  "客户管理/商业中心/修改客户团队成员状态": "management:business_center:team:member:status:update",
  "客户管理/商业中心/启用/禁用商业中心": "management:business_center:status:switch",
  "客户管理/商业中心/广告账户分页列表": "management:business_center:advertiser:list",
  "客户管理/商业中心/广告账户列表导出": "management:business_center:advertiser:export",
  "客户管理/商业中心/开户主体分页列表": "management:account_apply:list",
  "客户管理/商业中心/开通商业中心": "management:business_center:open",
  "客户管理/商业中心/授信申请分页列表": "management:biz_credit_apply:list",
  "客户管理/商业中心/操作日志分页列表": "business:log:menu",
  "客户管理/商业中心/数据监控查看": "management:data_monitoring:info",
  "客户管理/商业中心/新增授信申请": "management:biz_credit_apply:add",
  "客户管理/商业中心/显示/隐藏信用额度": "management:business_center:credit_line:display:switch",
  "客户管理/商业中心/查看客户团队成员列表": "management:business_center:team:member:list",
  "客户管理/商业中心/查看客户团队结构": "management:business_center:team:structure",
  "客户管理/商业中心/查看客户详情": "management:business_center:customerInfo:detail",
  "客户管理/商业中心/编辑客户详情": "management:business_center:customerInfo:edit",
  "客户管理/商业中心/重发激活邮件": "management:business_center:activation:email:resend",
  "客户管理/客户档案/为客户分配广告帐户": "management:customer_profile:assign_asset",
  "客户管理/客户档案/修改合同归档": "management:customer_profile:contract:edit",
  "客户管理/客户档案/合同分页列表": "management:customer_profile:contract:list",
  "客户管理/客户档案/客户关联广告帐户分页列表": "management:customer_profile:ad_account:list",
  "客户管理/客户档案/客户开户主体分页列表": "management:customer_profile:advertiser_holder:list",
  "客户管理/客户档案/客户档案下载合同": "management:customer_profile:download_contract",
  "客户管理/客户档案/客户档案申请开户": "management:customer_profile:account_apply",
  "客户管理/客户档案/客户档案详情": "management:customer_profile:detail",
  "客户管理/客户档案/客户编辑数据": "management:customer_profile:edit",
  "客户管理/客户档案/开户主体详情": "management:customer_profile:advertiser_holder:detail",
  "客户管理/客户档案/开通商业中心": "management:customer_profile:open_center",
  "客户管理/客户档案/新增合同归档": "management:customer_profile:contract:add",
  "客户管理/客户档案/新建客户档案": "management:customer_profile:add",
  "客户管理/客户档案/解除授权": "management:customer_profile:revoke_asset",
  "财务管理/授信审批/审批授信申请": "management:finance:credit_approval:review",
  "财务管理/授信审批/授信申请详情": "management:finance:credit_approval:detail"
} as const;

export type PermissionPath = keyof typeof PERMISSIONS;
export type PermissionCode = (typeof PERMISSIONS)[PermissionPath];
